export const EVENT_PAGE_SIZE = 50;

/** Calendar dates are local to the operator; the API takes UTC instants. */
export function eventDateBounds(fromDate: string, toDate: string) {
  const localMidnight = (date: string, nextDay = false) => {
    const [year, month, day] = date.split('-').map(Number);
    return new Date(year, month - 1, day + (nextDay ? 1 : 0)).toISOString();
  };
  return {
    dateFrom: fromDate ? localMidnight(fromDate) : '',
    dateTo: toDate ? localMidnight(toDate, true) : '',
  };
}

export function eventSearchQuery(filters: {
  page: number;
  state: string;
  device: string;
  site: string;
  siteResolution: string;
  dateFrom: string;
  dateTo: string;
}) {
  const q = new URLSearchParams({ limit: String(EVENT_PAGE_SIZE), offset: String(filters.page * EVENT_PAGE_SIZE) });
  for (const [key, value] of Object.entries({
    state: filters.state,
    device: filters.device,
    site: filters.site,
    site_resolution: filters.siteResolution,
    date_from: filters.dateFrom,
    date_to: filters.dateTo,
  })) if (value) q.set(key, value);
  return q.toString();
}
